module.exports = __webpack_public_path__ + "static/nish-menon-lg-de7e8284e32bc4c6425c65365b5e0866.png";